// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__RvyBZ","approved":"Status_approved__u8qhK","rejected":"Status_rejected__2yG4U","expired":"Status_expired__4Y3yT","label":"Status_label__3-jEs"};